import IncomeForm from "./IncomeForm";
import LoanOutstanding from "./LoanOutStanding";

export default IncomeForm;

export { LoanOutstanding };
